<!--
  添加组员
  lovi 2020-06-22
-->
<template>
  <div class="w100 childRoute-wrapper">
    <van-nav-bar
      :title="
        type == 1
          ? $t('transfer.addTransferObject')
          : $t('transfer.addTeamMembers')
      "
      :fixed="true"
      left-arrow
      @click-left="navBarBack"
    />
    <div class="scroll-wrapper">
      <van-cell
        :icon="httpUrl + data.avatar"
        :title="data.username"
        :label="_phoneDispose(data.phone)"
      />
      <div class="button-wrap">
        <van-button
          round
          type="primary"
          block
          :loading="btnLoading"
          @click="confirm"
        >
          {{ $t("common.confirm") }}
        </van-button>
        <p class="tips">
          {{ $t("transfer.transferTips") }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    groupId: {
      type: Number,
      default: function() {
        return 0;
      }
    },
    type: {
      type: Number,
      default: function() {
        return 0;
      }
    },
    data: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  components: {},
  data() {
    return {
      btnLoading: false
    };
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    navBarBack() {
      // 返回事件
      this.$emit("update:membersInfoFlag", false);
    },
    confirm() {
      // 确认
      if (this.type) {
        this.$emit("update:membersAddFlag", false);
        this.$emit("update:membersInfoFlag", false);
        this.$emit("getNewPeople");
      } else {
        this.addMember();
      }
    },
    addMember() {
      // 添加群组成员
      let vm = this;
      let params = {};
      params.group_id = vm.groupId;
      params.master_account = vm.data.username;
      vm.btnLoading = true;
      vm.$post("/app/transfer/addMember", params, {
        loading: true,
        alert: true
      }).then(res => {
        console.log("addMember", res);
        vm.btnLoading = false;
        vm.$toast(res.msg);
        if (res.code == 0) {
          this.$emit("update:membersAddFlag", false);
          this.$emit("update:membersInfoFlag", false);
          this.$emit("getListMember");
        }
      });
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
@images: "~@/assets/images/";
/deep/.van-cell {
  align-items: center;
  .van-cell__left-icon {
    margin-right: 10px;
    width: 44px;
    height: 44px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100%;
    img {
      width: 44px;
      height: 44px;
      border-radius: 4px;
    }
  }
}
</style>
